var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333008C7.79992 0.333008 0.333252 7.79967 0.333252 16.9997C0.333252 26.1997 7.79992 33.6663 16.9999 33.6663C26.1999 33.6663 33.6666 26.1997 33.6666 16.9997C33.6666 7.79967 26.1999 0.333008 16.9999 0.333008ZM16.9999 25.333C16.0833 25.333 15.3333 24.583 15.3333 23.6663V16.9997C15.3333 16.083 16.0833 15.333 16.9999 15.333C17.9166 15.333 18.6666 16.083 18.6666 16.9997V23.6663C18.6666 24.583 17.9166 25.333 16.9999 25.333ZM18.6666 11.9997H15.3333V8.66634H18.6666V11.9997Z",
    fill: "#008AC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.95c69aea24e65f3ebf2ad9faa045930f.svg";
export { ForwardRef as ReactComponent };